export default "__VITE_ASSET__Ca8dLo_d__"